import Link from '@commons/components/Link';

import type { PressReleaseNodeProps } from '.';

/**
 * Press Release node component for the Label display type.
 */

const PressReleaseNodeLabel = ({ title, link }: PressReleaseNodeProps) => {
  return <Link href={link.url}>{title}</Link>;
};

export default PressReleaseNodeLabel;
